/** Role permission shapes (match the backend's RolePermissions). */
export const SCOPES = [
  { value: 'ALL', label: 'All records' },
  { value: 'TEAM', label: 'Team’s records' },
  { value: 'OWN', label: 'Own records' },
  { value: 'NONE', label: 'None' },
]
export const RANK = { NONE: 0, OWN: 1, TEAM: 2, ALL: 3 }
export const FIELD_ACCESS = [
  { value: 'EDIT', label: 'Edit' },
  { value: 'READ_ONLY', label: 'Read-only' },
  { value: 'HIDDEN', label: 'Hidden' },
]

export const FULL = { view: 'ALL', create: true, edit: 'ALL', delete: 'ALL', fields: {} }

export const PRESETS = [
  { label: 'Full access', value: { view: 'ALL', create: true, edit: 'ALL', delete: 'ALL' } },
  { label: 'Own records', value: { view: 'OWN', create: true, edit: 'OWN', delete: 'NONE' } },
  { label: 'Team’s records (managers)', value: { view: 'TEAM', create: true, edit: 'TEAM', delete: 'NONE' } },
  { label: 'Read only', value: { view: 'ALL', create: false, edit: 'NONE', delete: 'NONE' } },
  { label: 'No access', value: { view: 'NONE', create: false, edit: 'NONE', delete: 'NONE' } },
]

/** Edit and delete can't reach further than view. */
export const clamp = (p) => {
  const cap = (s) => (RANK[s] > RANK[p.view] ? p.view : s)
  return { ...p, edit: cap(p.edit), delete: cap(p.delete) }
}

export const emptyRole = () => ({ name: '', description: '', isDefault: false, permissions: { defaults: { ...FULL }, entities: {} } })

/** "Deals: own · Tasks: read only · others: none" */
export const summarize = (permissions, label) => {
  const describe = (p) => {
    if (p.view === 'NONE') return 'no access'
    const scope = { OWN: 'own', TEAM: 'team' }[p.view] || 'all'
    if (p.edit === 'NONE' && !p.create) return `view ${scope}`
    const restricted = Object.keys(p.fields || {}).length
    return `${scope}${p.delete === 'NONE' ? ', no delete' : ''}${restricted ? `, ${restricted} field${restricted === 1 ? '' : 's'} restricted` : ''}`
  }
  const parts = Object.entries(permissions.entities || {}).map(([type, p]) => `${label(type)}: ${describe(p)}`)
  parts.push(`${parts.length ? 'other types' : 'all types'}: ${describe(permissions.defaults)}`)
  return parts.join(' · ')
}
